module.exports = __webpack_public_path__ + "static/img/icons8-download.6fa46df9.svg";